import { Grid, Tabs, Tab, Box, Stack, Typography } from "@mui/material";
import { ListContextProvider, useListController } from "ra-core";
import { FC, useState } from "react";
import { Content } from "@/components/content/Content";
import DatabaseUpdatesTable from "@/components/governance/DatabaseUpdatesTable";
import { DataCatalogTile, DataClassificationTile, DataOwnershipTile, PlaceholderTile } from "@/components/governance/entryTiles";
import AlphabeticalDatabaseList from "@/components/governance/AlphabeticalDatabaseList";
import { OdResourcePageProps } from "@/types/resource";
import SecurityIcon from '@mui/icons-material/Security';
import { useResourceRegister } from "@/utils/resourceRegister";

const GovernanceDashboard: FC<OdResourcePageProps> = () => {
  useResourceRegister({ name: 'govrnc-databases' })
  const [activeTab, setActiveTab] = useState<'metadata' | 'ownership'>('metadata');

  const listCtrl = useListController({ resource: 'govrnc-dashboard', basePath: '', sort: { field: 'name', order: 'ASC'} })

  const dbOptionsCtrl = useListController({ resource: 'govrnc-databases', basePath: '', });

  return (
    <Content pageName="Data Catalog" resourceName="Data Catalog">
      <Grid
        container
        spacing={4}
        sx={{ pt: 2 }}
      >
        <Grid item xs={12} sm={6} md={3}>
          <DataCatalogTile />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataClassificationTile />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <DataOwnershipTile />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <PlaceholderTile name="Data Audit" icon={<SecurityIcon />} />
        </Grid>
        <Grid item xs={12}>
          <Stack direction="row" alignItems="center" sx={{ mt: 2, borderBottom: theme => `1px solid ${theme.palette.divider}` }}>
            <Typography variant="h6" color="textPrimary" mr={"15%"}>
              Databases
            </Typography>
            
            {/* Tab Navigation */}
            <Tabs sx={{ '& button.MuiTab-root': { textTransform: 'unset' } }}
              value={activeTab}
              onChange={(_, value) => setActiveTab(value)}
            >
              <Tab label="Semantic Data" value="metadata" data-testid="metadata-tab" />
              <Tab label="Ownership" value="ownership" data-testid="ownership-tab" />
            </Tabs>
          </Stack>

          {/* Tab Content */}
          <Box sx={{ mt: 2 }}>
            {activeTab === 'metadata' ? (
              <div data-testid="metadata-content">
                <ListContextProvider value={dbOptionsCtrl}>
                  <AlphabeticalDatabaseList />
                </ListContextProvider>
              </div>
            ) : (
              <div data-testid="ownership-content">
                <ListContextProvider value={listCtrl}>
                  <DatabaseUpdatesTable />
                </ListContextProvider>
              </div>
            )}
          </Box>
        </Grid>
      </Grid>
    </Content>
  )
}

export default GovernanceDashboard;
